import { render, staticRenderFns } from "./GradeSetup.vue?vue&type=template&id=5fedcbd5&"
import script from "./GradeSetup.vue?vue&type=script&lang=js&"
export * from "./GradeSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports